module.exports = __webpack_public_path__ + "static/media/z&v3.11c00d59.jpg";